import {MOON_500} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Placeholder = styled.div`
  color: ${MOON_500};
`;
